// web-vitals v5 API: getCLS/getFID/getFCP/getLCP/getTTFB are replaced by
// onCLS/onINP/onFCP/onLCP/onTTFB. FID is deprecated in favor of INP.
const reportWebVitals = (onPerfEntry) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ onCLS, onINP, onFCP, onLCP, onTTFB }) => {
      onCLS(onPerfEntry);
      onINP(onPerfEntry);
      onFCP(onPerfEntry);
      onLCP(onPerfEntry);
      onTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
